(ns ncr.etc.pubsub
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [cljs.core.async.impl.protocols :as ap]
   [uix.core.alpha :as uix]))

(defonce subscriptions
  (atom {}))

(defonce inbox
  (async/chan 8))

(defn- sub! [topics sub-fn]
  (uix/effect!
    (fn []
      (let [sub-fn [(gensym) sub-fn]]
        (reset! subscriptions
          (reduce
            (fn [subs topic]
              (update subs topic conj sub-fn))
            @subscriptions topics))

        (fn []
          (reset! subscriptions
            (reduce
              (fn [subs topic]
                (update subs topic
                  (fn [subs]
                    (filter
                      #(not= sub-fn %) subs))))
              @subscriptions topics)))))))

(defn use-sub! [topic sub-fn]
  (sub! [topic]
    (fn [[_ message]]
      (sub-fn message))))

(defn- handlers [topic]
  (some->> (get @subscriptions topic) (map second) reverse))

(go
  (loop []
    (when-let [[topic & _ :as message] (<! inbox)]
      (doseq [handler (handlers topic)]
        (let [return (handler message)]
          (when (satisfies? ap/ReadPort return)
            (<! return))))
      (recur))
    (.error js/console "inbox closed, this should not happen normally")))

(defn pub! [message]
  (async/put! inbox message))

(defn pub-sync! [[topic & _ :as message]]
  (doseq [handler (handlers topic)]
    (let [return (handler message)]
      (when (satisfies? ap/ReadPort return)
        (.warn js/console "pub-sync! to async handler" message handler))))
  nil)

(defn make-update-fn [state reducers]
  (fn [[topic & args]]
    (let [reduce-fn (get reducers topic)]
      (let
        [new-state
         (try
           (apply reduce-fn @state args)
           (catch js/Error e
             (js/console.error e)
             @state))]
        (reset! state new-state)
        new-state))))

(defn sub-reducer-map! [initial reducers]
  (let [state (uix/state initial)]
    (sub! (keys reducers) (make-update-fn state reducers))
    state))

(defonce global-state
  (atom {}))

(defn sub-reducer-map-persistent! [key initial reducers]
  (let
    [state (uix/state (get @global-state key initial))
     update-fn (make-update-fn state reducers)]
    (sub! (keys reducers)
      #(let [new-state (update-fn %)]
         (swap! global-state assoc key new-state)))
    state))